import { Star, MessageCircle, ExternalLink } from "lucide-react";
import { GOOGLE_REVIEWS_URL, waLink } from "@/lib/site";
import { Reveal } from "@/components/Reveal";
import { GoldDivider } from "@/components/GoldDivider";
import { StarField } from "@/components/StarField";
import { useLang } from "@/i18n";

export const Reviews = () => {
    const { t } = useLang();

    return (
        <section id="testimonios" data-testid="testimonials-section" className="relative py-24 sm:py-32 px-5 sm:px-8 bg-ink-deep overflow-hidden">
            <div
                className="absolute inset-0 pointer-events-none candle-glow"
                style={{ background: "radial-gradient(ellipse 50% 40% at 15% 90%, rgba(74,14,28,0.45) 0%, transparent 65%)" }}
                aria-hidden="true"
            />
            <StarField count={30} />
            <div className="absolute top-0 left-0 right-0 h-28 section-fade-top" aria-hidden="true" />
            <div className="absolute bottom-0 left-0 right-0 h-28 section-fade-bottom" aria-hidden="true" />

            <div className="relative max-w-3xl mx-auto text-center">
                <Reveal>
                    <p className="font-accent text-[11px] tracking-[0.4em] uppercase text-gold-soft mb-4">
                        {t("reviews.eyebrow")}
                    </p>
                    <h2 className="font-display font-semibold gold-text text-4xl sm:text-5xl tracking-wide">
                        {t("reviews.title")}
                    </h2>
                    <GoldDivider className="my-8" />
                </Reveal>

                <Reveal delay={0.1}>
                    <div className="ornament-frame bg-surface/90 border border-gold/30 rounded-sm px-8 py-12 sm:px-14">
                        <div className="flex justify-center gap-1.5 mb-7" aria-hidden="true">
                            {Array.from({ length: 5 }, (_, i) => (
                                <Star key={i} className="w-5 h-5 text-gold/70" strokeWidth={1.25} />
                            ))}
                        </div>
                        <p className="font-display italic text-lg sm:text-xl text-cream/85 leading-relaxed max-w-xl mx-auto">
                            {t("reviews.text")}
                        </p>
                        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10">
                            {GOOGLE_REVIEWS_URL && (
                                <a
                                    href={GOOGLE_REVIEWS_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="reviews-google-button"
                                    className="inline-flex items-center gap-2.5 bg-gold text-ink font-accent text-[11px] tracking-[0.2em] uppercase font-bold px-8 py-3.5 rounded-sm hover:brightness-110 hover:shadow-[0_0_26px_rgba(212,175,55,0.35)] transition-[box-shadow,filter] duration-300"
                                >
                                    <ExternalLink className="w-4 h-4" /> {t("reviews.googleCta")}
                                </a>
                            )}
                            <a
                                href={waLink(t("wa.reviewShare"))}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="testimonials-share-button"
                                className="inline-flex items-center gap-2.5 border border-gold/45 text-gold font-accent text-[11px] tracking-[0.2em] uppercase px-8 py-3.5 rounded-sm hover:bg-gold/10 hover:shadow-[0_0_20px_rgba(212,175,55,0.2)] transition-[background-color,box-shadow] duration-300"
                            >
                                <MessageCircle className="w-4 h-4" /> {t("reviews.shareCta")}
                            </a>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
};
